<template>
  <div
    class="search__input"
    :class="{
      'search__input-expanded': showSearchInput
    }"
  >
    <ButtonText
      v-if="showSearchInput && mobileScreen"
      class="search__toggle-collapse"
      :icon-left="iconChevronLeft"
      size="medium-icon"
      @click="toggleSearchInput(false)"
    />
    <TextFieldStandard
      v-if="showSearchInput || !mobileScreen"
      :placeHolderText="placeholderText"
      :search-input="true"
      :clearInput="clearInput"
      @click="toggleSearchInput(true)"
      @emitInput="(v) => submitSearch(v.toString())"
      @emitClearInput="submitSearch('')"
    />
  </div>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue'
import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import TextFieldStandard from '@/design-system/atoms/TextFieldStandard.vue'
import iconChevronLeft from '@/design-system/assets/icons/Icon-Chevron-Left.svg'
const props = defineProps({
  mobileScreen: {
    type: Boolean,
    required: false
  },
  showSearchInput: {
    type: Boolean,
    required: false
  },
  placeholderText: {
    type: String,
    default: ''
  },
  clearInput: {
    type: Boolean,
    default: false
  }
})
const { mobileScreen, showSearchInput, placeholderText, clearInput } = toRefs(props)
interface EMITS {
  (e: 'toggleSearchInput', active: boolean)
  (e: 'emitSearchString', searchString: string)
}
const emits = defineEmits<EMITS>()
async function submitSearch(string: string) {
  if (string.length && !showSearchInput.value) {
    // Show the search overlay when typing after using keyboard tab to navigate to search field
    toggleSearchInput(true)
    await new Promise((resolve) => setTimeout(resolve, 200)) // Wait for the search input to be visible before emitting the search string
  }
  emits('emitSearchString', string)
}
function toggleSearchInput(active: boolean) {
  emits('toggleSearchInput', active)
}
</script>
<style scoped lang="scss">
@use '@/design-system/design-tokens/variables.scss';

.search {
  &__input {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: variables.$gap-large;
  }
  &__toggle-collapse {
    margin-left: variables.$margin-medium;
  }
}
</style>
